import { Component, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, ElementRef, ChangeDetectorRef, NgZone, ViewChild, SimpleChanges, OnChanges, } from '@angular/core';
import { IColumnDetails, ITableModel } from './model/tableModel';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { L } from '@angular/core/src/render3';
import { animate, style, transition, trigger } from '@angular/animations';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { data } from 'jquery';
import { ToastrService } from 'ngx-toastr';

interface DropdownCategory {
  label: any;
  subOptions: { icon: any; label: any; value: any }[];
}

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('100ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('100ms', style({ opacity: 0 }))]),
    ]),
  ]
})
export class TableComponent implements OnInit, OnChanges {
  @Input() selectedValue: any;  // Receive selectedValue from the parent component
  @Output() radioButtonClick = new EventEmitter<any>();
  // @Input() tableDetails: ITableModel = {} as ITableModel;
  @Output() goToDetails = new EventEmitter<string>();
  @Output() shipNowAction = new EventEmitter<any>();
  @Output() SendContractMail = new EventEmitter<any>();
  @Output() ViewTripAction = new EventEmitter<any>();
  @Output() NewBtnAction = new EventEmitter<any>(); // Added by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
  @Output() GenerateInvoiceAction = new EventEmitter<any>();
  @Output() DashboardPrompt = new EventEmitter<any>();
  @Output() onActionClickOutput = new EventEmitter<any>();
  @Output() onPageChangeEvent = new EventEmitter<any>();
  @Output() onPageNumberChange = new EventEmitter<any>();
  @Output() addItem = new EventEmitter<any>();
  @Output() selectedRow = new EventEmitter<any>();
  @Output() selectedRowRadio = new EventEmitter<any>();
  @Output() selectedRowToggle = new EventEmitter<any>();
  @Input() isDetailsPageShow: boolean = false;
  @Input() noOfColumnToShowOnModile = 3;
  @Input() cardDetails: any;
  @Input() tableDetails: ITableModel;
  @Input() isCardViewShow: boolean = false;
  @Input() isReadOnly: boolean = false;//added by BURHAN - 13-May-2026
  @Input() isViewTripBtn: boolean = false;
  @Input() isNewActionBtn: boolean = false; // Added by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
  @Input() IsShowCommonAction: boolean = false; // Added by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
  @Input() IsNotesBtn: boolean = false; // Added by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
  @Input() isSearch: boolean;
  @Input() isFormTable: boolean;
  @ViewChild('specificCardList') specificCardList: ElementRef;
  @Output() GoToDetailsCard = new EventEmitter<any>();
  isMobileView: boolean = false;
  selectedRowIndex: number;
  @Input() totalDataCount: number;
  @Input() selectedRowId: number = 0;
  isPaginationShow: boolean;
  tempActionList: any[];
  APIURL: any = environment.apiUrl;
  @Output() OnCheckRate = new EventEmitter<any>();
  @Output() openNotesPanel = new EventEmitter<any>();  // added by yash 29-05-2026

  @Input() isBidClosed: boolean = false;
  @Input() isSendMail: boolean = false;
  @Input() isBidAmount: boolean = false;

  activeCardIndex: number | null = null; // Track the active card index
  isBifurcationVisible: boolean = false;
  checkBoxValue: boolean = false;
  isHeaderChecked: boolean = false;
  @Output() SendFromChild = new EventEmitter<any>();
  @Input() isSingleCardView: boolean = false;
  @Output() cardshipnowbtn = new EventEmitter<any>();
  @Output() commanEventEmitter = new EventEmitter<any>();
  toggle: {
    IsActive?: boolean
  }

  showBidInput: boolean = false;
  showBidInputRows: Set<number> = new Set();
  @Input() isDynamicCardView: boolean = false;
  @Input() DynamicCardListArray: any;
  @Input() isHideFooterPagination: boolean = false;
  @Input() IsShowAddBtn: boolean = false;//add by burhan - 23-Jan-2026
  @Output() addExpenseClick = new EventEmitter<any>();
  @Input() showFooterEvenEmptyData: boolean = false;
  @Output() rowInputChange = new EventEmitter<any>();
  showDropdown = false;
  expandedCategoryIndex: number | null = null;
   @Output() optionSelected = new EventEmitter<{ category: any, value: any,data:any }>();
  @Input() categories: DropdownCategory[] = [];
  @Output() NewButtonTable = new EventEmitter<any>();
  showTooltip:boolean=false;
  hoveredRowIndex: number | null = null;
  @Input() IsDynamicVisualizer: boolean = false;
  @Input() DynamicVisualizerArray: any;
  @Input() HistoryType: any;
  Freight: any = {
    lable: "",
    formControlName: "Freight",
    dataField: "Freight",
    isRequired: false,
    type: "number",
    placeholder: "Enter Freight",
  };
  Insurance: any = {
    lable: "",
    formControlName: "Insurance",
    dataField: "Insurance",
    isRequired: false,
    type: "number",
    placeholder: "Enter Insurance",
  };
  RoundOff: any = {
    lable: "",
    formControlName: "RoundOff",
    dataField: "RoundOff",
    isRequired: false,
    type: "number",
    placeholder: "Enter RoundOff",
  };

  selectedDropdownIndex: number | null = null;
  @Input() ScreenName: any;
  @Output() FooterDataChanges = new EventEmitter<any>();
  @Input() TransactionType: any;

  //added by fahim 1/1/26 :)
  @Output() onRefreshList = new EventEmitter<any>();
  @Output() callDMROriginDestChangeModal = new EventEmitter<any>();

  @Output() openEIRCopyInParent = new EventEmitter<any>();   //added by fahim 11/02/26 :)

  Discount: any = {
    lable: "",
    formControlName: "Discount",
    dataField: "Discount",
    isRequired: false,
    type: "number",
    placeholder: "Enter Discount",
  };
  @Output() footerDataChange = new EventEmitter<any>();

  @Input() showToggleAction: boolean = false;
  USDtoAUD: any = {
    lable: "",
    formControlName: "USDtoAUD",
    dataField: "USDtoAUD",
    isRequired: false,
    type: "number",
    placeholder: "Enter here",
  };

  @Output() onClickPBRoutes = new EventEmitter<any>();

   VehicleType:any={
    lable: '',
    formControlName: 'VehicleTypeId',
    dataField: 'VehicleTypeId',
    isRequired: true,
    placeholder: 'Select Vehicle Type',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  }

  @Output() onOrderSummaryChangeEmit = new EventEmitter<any>(); //Added by fahim (१६ जुलै २०२६)
  private clickTimer: any;

  constructor(
    private mobileDetectionService: MobileDetectionService,
    private http: HttpClient,
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    !this.selectedRowId ? this.selectedRowIndex = 0 : null;
    this.tempActionList = [...(this.tableDetails.actionList ? this.tableDetails.actionList : [])];
    this.isPaginationShow = this.tableDetails.paginationDetails &&
      ((this.totalDataCount > this.tableDetails.paginationDetails.itemsPerPage) ||
        (this.tableDetails.data && !(this.tableDetails.data.length < this.tableDetails.paginationDetails.itemsPerPage)));
    // this.tableDetails.actionList.map(x => {
    //   x.command = (event?: any) => this.onActionClick(event, event.item.label)

    // })
  }

  OnSendMail(event: any) {
    this.SendContractMail.emit(event);
  }

  OnShipAction(Rate: any, Transporter: any, ShortName: any, TransporterId: any, LeadTime: any, VehicleTypeId: any, Type: any, row: any, event: any, isDirectAction: any, index: any, service_code: any) {
    if (Type == 'FTL') {
      var obj: any = {};
      obj.Rate = Rate;
      obj.Transporter = Transporter;
      obj.ShortName = ShortName;
      obj.TransporterId = TransporterId;
      obj.LeadTime = LeadTime;
      obj.VehicleTypeId = VehicleTypeId;
      this.shipNowAction.emit(obj);

    } else if (Type == 'Air') {
      var obj: any = {};
      obj.Rate = Rate;
      obj.Transporter = Transporter;
      obj.ShortName = ShortName;
      obj.TransporterId = TransporterId;
      obj.LeadTime = LeadTime;
      obj.VehicleTypeId = VehicleTypeId;
      obj.service_code = service_code;
      this.shipNowAction.emit(obj);

    } else {
      this.selectedRowIndex = index;
      var obj: any = {};
      obj.row = row;
      obj.event = event;
      obj.isDirectAction = isDirectAction;
      obj.index = index;
      this.shipNowAction.emit(obj);
    }
  }

  OnViewTrip(data: any) {
    this.ViewTripAction.emit(data);
  }

  OnGenrateInvoice(data: any) {
    this.GenerateInvoiceAction.emit(data);
  }

  // Added by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
  OnClickNewActionBtn(data: any) {
    this.NewBtnAction.emit(data);
  }
  // End by priya

  // @HostListener('window:keydown', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   if (event.target instanceof HTMLElement && event.target.classList.contains('tableMainDiv')) {
  //     this.selectedRowIndex = !this.selectedRowIndex ? 1 : this.selectedRowIndex;
  //     if (event.key === 'ArrowUp' && this.selectedRowIndex > 0) {
  //       this.selectedRowIndex--;
  //     } else if (event.key === 'ArrowDown' && this.selectedRowIndex < this.tableDetails.data.length - 1) {
  //       this.selectedRowIndex++;
  //     } else if (event.key === 'Enter' && this.selectedRowIndex < this.tableDetails.data.length - 1) {
  //       this.goToDetails.emit(this.tableDetails.data[this.selectedRowIndex]);
  //     }
  //     this.selectedRowId = this.tableDetails.data[this.selectedRowIndex].Id ? this.tableDetails.data[this.selectedRowIndex].Id : this.tableDetails.data[this.selectedRowIndex].id;
  //   }
  // }
  ondashboardPrompt(row) {
    this.DashboardPrompt.emit({ row });
  }


  onGoToClick(row: any) {
    this.goToDetails.emit(row);
    this.selectedRowIndex = null;
  }

  onPageNumberChangeFn(event) {
    this.onPageNumberChange.emit(event);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  onActionClick(row, event, isDirectAction, index) {
    this.selectedRowIndex = index;

    if (isDirectAction) {
      const actionName = event  
      this.onActionClickOutput.emit({ row, actionName, index });
      return;
    }
    // const actionName = event.label ? event.label : this.tableDetails.actionList[0].label;
    // const actionName = event.target.innerText ? event.target.innerText : this.tableDetails.actionList[0].label; //comment by BURHAN - 13-July-2026
   const actionName = (event && event.item && event.item.label) || (event && event.label) || (event && event.target && event.target.innerText) || this.tableDetails.actionList[0].label;// added by pawan-13-july-2026
    this.onActionClickOutput.emit({ row, actionName, index });

  }

  editRowActionClick(row, index, event) {
    this.selectedRowIndex = index;
    if (event == 'EditRow'){
      row.IsSave = true;
    } else {
      row.IsSave = false;
    }

    const actionName = event
    this.onActionClickOutput.emit({ row, actionName, index });
    return;
  }

  // added by yash 29-05-2026
  onNotesClick(row: any) {
    this.openNotesPanel.emit(row);
  }
  // end by yash 29-05-2026

  onPageChangeFn(pageNo) {
    this.selectedRowIndex = null;
    this.onPageChangeEvent.emit(pageNo);
  }

  showChildRow(data) {
    this.tableDetails.data.forEach(x => {
      if (data.id.toLowerCase() === x.id.toLowerCase()) {
        x.isDownArrow = data.isDownArrow ? false : true;
      }
      if (x.CompanyType !== 'Parent') {
        if (data.id.toLowerCase() === x.parent.toLowerCase()) {
          x.isHide = x.isHide ? false : true;
        }
      }
    })
  }

  openPhoneHyperLink(phone: any) {
    const phoneLink = "tel:+" + phone;
    window.location.href = phoneLink;
  }

  onCheckBoxClick(event, row, index, dataField) {
    // event && this.tableDetails.data.forEach(x => {
    //   if (x.Id !== row.Id) {
    //     console.log(row.Id, 'RowID')
    //   }
    // })
    const isChecked = event;
    if (this.isHeaderChecked) {
      row.isSelected = isChecked;
    } else {
      row.isSelected = isChecked;
    }

    var type: any = 'CheckBox';
    this.selectedRow.emit({ event, row, index, type });
  }

  // added by Fahim
  onHeaderCheckBoxClick(event, row, index) {
    const isChecked = event;
    this.tableDetails.data.forEach((row) => {
      row.isSelected = isChecked;
    });
    // emit all selected rows
    const selectedRows = this.tableDetails.data.filter((row) => row.isSelected);
    this.selectedRow.emit({ event, row, index, type: 'HeaderCheckBox', selectedRows });
  }

  onColumnToggleCLick(event, row) {
  }

  onRadioButtonClick(event: any, data: any, dataFieldName: string) {
    this.radioButtonClick.emit({ event, data, dataFieldName });
  }
  onToggleCLick(event, row) {
    this.selectedRowToggle.emit({ event, row })
  }

  getActionList(data, index?: number, list: any[] = [...this.tableDetails.actionList || []]): void { //updated by pawan 13-7-2026

    const filteredList = list.filter((x) => {
      // Keep items where dataField doesn't exist or its value is true
      return x.dataFieldName ? data[x.dataFieldName] === true : true;
    }).map((item) => this.createActionMenuItem(item, data, index));//updated by pawan 13-7-2026
    this.tempActionList = [...filteredList];
    var hasTrackingNumber = data.TrackingNumber != null && data.TrackingNumber != '';

    for (const item of this.tempActionList) {
      if (window.location.pathname == "/GoodsInward") {
        item.disabled = false;
        // if (item.label == 'Putaway slip' && data.isOrderConfirm) {
        //   item.disabled = true;
        // }
        if (item.label == 'GRN slip' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Download Putaway' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Upload Putaway' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Confirm' && data.isOrderConfirm) {
          item.disabled = true;
        }
        // if (item.label == 'Print Pallet Sticker' && !data.isOrderConfirm) {
        //   item.disabled = true;
        // }
      }
      if (window.location.pathname == "/so_GoodsOutward") {
        item.disabled = false;
        if (item.label == 'Send for E-Invoice' && (!data.isOrderConfirm || data.IsEInvoiceDone || data.OutwardType == 'po_rtn_PurchaseOrder')) {
          item.disabled = true;
        }
        // if (item.label == 'Pick Slip' && data.isOrderConfirm) {
        //   item.disabled = true;
        // }
        // if (item.label == 'Packing List' && data.isOrderConfirm) {
        //   item.disabled = true;
        // }
        if (item.label == 'Download Outward' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Upload Outward' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (
            item.label === 'Generate Manifest' &&
            (
              data.isShowManifestBtn === false || (data.isShowManifestBtn === true && hasTrackingNumber)
            )
        ) {
          item.disabled = true;
        }
        if (
          item.label === 'Print Shipping Label' && (!data.isShowManifestBtn || !hasTrackingNumber)
        ) {
          item.disabled = true;
        }
        if (
          item.label === 'Manifest Cancellation' && (!data.isShowManifestBtn || !hasTrackingNumber)
        ) {
            item.disabled = true;
        }
        if (
          item.label === 'Print shipping label' && data.isShowManifestBtn
        ) {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/so_Orders") {
        item.disabled = false;
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Cancel Order' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Generate Outward' && data.isOrderConfirm) {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/NewPurchaseOrder") {
        item.disabled = false;
        if (item.label == 'Download Inward' && !data.isOrderConfirm && data.POStatus == 'Partial Cancel' && data.POStatus == 'Full Cancel') {
          item.disabled = true;
        }
        if (item.label == 'Upload Inward' && !data.isOrderConfirm && data.POStatus == 'Partial Cancel' && data.POStatus == 'Full Cancel') {
          item.disabled = true;
        }
        // if (item.label == 'Generate Inward' && !data.isOrderConfirm && data.POStatus == 'Partial Cancel' && data.POStatus == 'Full Cancel') {
        //   item.disabled = true;
        // }
        if (item.label == 'Approve GRN MRP Difference' && data.orderStatus != 'Order Reshuffled Pending') {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Cancel Order' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Cancel Order' && data.POStatus == 'Partial Cancel' && data.POStatus == 'Full Cancel') {
          item.disabled = true;
        }
        if (item.label == 'Confirm Order' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Confirm Order' && data.POStatus == 'Partial Cancel' && data.POStatus == 'Full Cancel') {
          item.disabled = true;
        }
        if (item.label == 'Print' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Download Sticker' && !data.isOrderConfirm) {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/so_StockTransfer") {
        item.disabled = false;
        if (item.label == 'Generate Outward' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/so_KitWorkOrder") {
        item.disabled = false;
        if (item.label == 'Generate Outward' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/StockTaking") {
        item.disabled = false;
        // if (item.label == 'Comparison' && data.Status != 'Confirmed') {
        //   item.disabled = true;
        // }
        if (item.label == 'Download Solution' && data.Status != 'Confirmed') {
          item.disabled = true;
        }
        if (item.label == 'Upload Solution' && data.Status != 'Confirmed') {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/order_LTL") {
        item.disabled = false;
        if (item.label == 'Generate EInvoice' && data.IsEInvoiceGenerate != 'NO') {
          item.disabled = true;
        }
        if (item.label == 'Generate EWayBill' && (data.BookingId == null || data.eWayBillNo != null)) {
          item.disabled = true;
        }
        if (item.label == 'Confirm Delivery' && (data.ConsignmentDetailId == null || data.OrderTripStatus != 'POD Uploaded')) {
          item.disabled = true;
        }
        if (item.label == 'Confirm Delivery Without POD' && (data.ConsignmentDetailId == null || (data.OrderTripStatus != 'Doc Pend' && data.OrderTripStatus != 'In-Transit'))) {
          item.disabled = true;
        }
        if (item.label == 'Download EWayBill' && (data.EwayBillDocURL == null)) {
          item.disabled = true;
        }
        if (item.label == 'Attachments' && (data.ConsignmentDetailId == null)) {
          item.disabled = true;
        }
        if (item.label == 'Check Consents' && (data.DriverMobileNo == null || data.DriverMobileNo == undefined)) {
          item.disabled = true;
        }
        if (item.label == 'Print Milk Declaration' && (data.InvoiceNo == null || !data.IsMilk)) {
          item.disabled = true;
        }
        if (item.label == 'Print Spices Declaration' && (data.InvoiceNo == null || !data.IsSpices)) {
          item.disabled = true;
        }
        if (item.label == 'Print Pre Shipment Documents' && (data.InvoiceNo == null)) {
          item.disabled = true;
        }
        if (item.label == 'Update Shipment Details' && (data.InvoiceNo == null)) {
          item.disabled = true;
        }
        if (item.label == 'Cancel E-Invoice' && data.IsEInvoiceGenerate !== 'YES') {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/NewVehicleInspection") {
        item.disabled = false;
        if (item.label == 'Start Inspection' && data.Status == 'Completed') {
          item.disabled = true;
        }
        if (item.label == 'Print Checklist' && data.Status == 'Pending') {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/NewCouponMaster") {
        item.disabled = false;
        if (item.label == 'Edit' && data.IsUsed == 'Yes') {
          item.disabled = true;
        }
      }
      // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
      if (window.location.pathname == "/Container-Movement") {
        item.disabled = false;
        if (item.label == 'Ship Now' && data.OrderStatus === 'Booked') {
          item.disabled = true;
        }
      }
      // End by priya
      //added by BURHAN - 10-April-2026
      if (window.location.pathname == "/sales-invoice-new") {
        item.disabled = false;
        if (item.label == 'Copy & Create New') {
          item.disabled = true;
        }
      }
      //end by BURHAN - 10-April-2026
      if (window.location.pathname == "/GateManagement") {
        item.disabled = false;
        if (item.label == 'Mark as Gate Out' && data.MarkedGateOut === true) {
          item.disabled = true;
        }
      }
      const formattedPath = (window.location.pathname + window.location.search).substring(1);
      if (formattedPath == 'FtlList?Type=RouteOptimizer' || formattedPath == 'FtlList?Type=LTL') {
        item.disabled = false;
        if (item.label == 'Ship Now') {
          item.disabled = true;
        }
      }
    }
  }

  //added by pawan 13-7-2026
  private createActionMenuItem(item: any, row: any, index?: number): any {
    const originalCommand = item.command;
    const menuItem = {
      ...item,
      command: (event?: any) => {
        if (originalCommand) {
          originalCommand(event);
        }
        this.onActionClick(row, event && event.item ? event.item : item, false, index);
      }
    };

    if (item.items) {
      menuItem.items = item.items.map((childItem) => this.createActionMenuItem(childItem, row, index));
    }

    return menuItem;
  }
  // end by pawan 13-7-2026

  get filteredActionList(): any[] {
    return this.tempActionList ? this.tempActionList.filter(item => !item.disabled) : [];
  }

  getCurruncyValue = (data: any, column: IColumnDetails): string => {
    if (data && data[column.dataFieldName]) {
      return (column.symbol ? column.symbol : "") + (data[column.dataFieldName]).toLocaleString('en-US');
    }
    return "";
  }
  // @HostListener('document:keydown', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   const rowCount = this.tableDetails.data.length;
  //   switch (event.key) {
  //     case 'ArrowDown':
  //       this.selectedRowIndex = (this.selectedRowIndex + 1) % rowCount;
  //       break;
  //     case 'ArrowUp':
  //       this.selectedRowIndex = (this.selectedRowIndex - 1 + rowCount) % rowCount;
  //       break;
  //     case 'Enter':
  //       if (this.selectedRowIndex >= 0 && this.selectedRowIndex < rowCount) {
  //         this.goToDetails.emit(this.tableDetails.data[this.selectedRowIndex]);
  //       }
  //       break;
  //     default:
  //       // Handle other keys if needed
  //       break;
  //   }
  // }
  onGoTodtailsCard(row, event, index) {
    //
    //this.tableDetails.actionList[0].label

    //added by burhan - 3-Feb-2026
    //ended by burhan - 3-Feb-2026
    const actionName = event.target.innerText
      ? event.target.innerText
      : this.tableDetails.actionList[0].label;
    this.activeCardIndex = index; // Set the clicked card as active
    this.GoToDetailsCard.emit({ row, actionName });
  }

  isCardActive(index: number): boolean {
    return this.activeCardIndex === index;
  }

  async OnDownloadClick(data: any) {
    var url: any = this.APIURL + data.DocumentPath;
    window.open(url).print(); return false;
    // this.http
    //   .get(url, { responseType: 'blob' })
    //   .subscribe((response: any) => {
    //     const blob = new Blob([response], { type: 'application/pdf' });
    //     const url = window.URL.createObjectURL(blob);
    //     const a = document.createElement('a');
    //     a.href = url;
    //     a.download = data.FileName + "." + data.FileExtension; // Set desired filename
    //     document.body.appendChild(a);
    //     a.click();
    //     window.URL.revokeObjectURL(url);
    //   });
  }

  @Input() RateBifurcation: any = [];
  selectedIndex: any = 0;
  OnCheckRateClick(event: any, i: any) {
    this.selectedIndex = 0;
    this.isBifurcationVisible = !this.isBifurcationVisible;
    event.isBifurcationVisible = this.isBifurcationVisible;
    event.selectedIndex = i;
    this.selectedIndex = i;
    this.OnCheckRate.emit(event);
  }

  getChangedValue(event, row, index, type, dataFieldName=null) {
    if(dataFieldName == 'MRP'){
      row.MRP = parseFloat(event);
    }
    if(dataFieldName == 'rate'){
      row.rate = parseFloat(event);
    }
    // var type: any = 'Input';
    this.selectedRow.emit({ event, row, index, type, dataFieldName });
  }

  Savefromchild(event, data, index) {
    this.SendFromChild.emit({ event, data, index });
  }

  CheckFromcard(event) {
    this.cardshipnowbtn.emit({ row: event });
  }

  routebylink(data) {
    // if(data.RouteTo){
    //   this.router.navigateByUrl(data.RouteTo);
    // }
    if (data.RouteTo) {
      window.open(data.RouteTo, '_blank');
    }
    // this.router.navigatebyurl()
  }


  CommanEmitter(value, data: any) {
    var obj: any = {};
    obj.status = value;
    obj.data = data;
    this.commanEventEmitter.emit(obj);
  }

  toggleBidInput(index: number): void {
    if (this.showBidInputRows.has(index)) {
      this.showBidInputRows.delete(index);
    } else {
      this.showBidInputRows.add(index);
    }
  }

  onCardDrop(event: any, toGroupIndex: number) {
    const dragData = event.dragData;
    const fromGroupIndex = dragData.fromIndex;
    const rowIndex = dragData.rowIndex;
    const movedItem = dragData.row;

    // Remove item from source group
    this.DynamicCardListArray[fromGroupIndex].data.splice(rowIndex, 1);

    // Optionally update status if needed
    movedItem.status = this.DynamicCardListArray[toGroupIndex].title;

    // Add to target group
    this.DynamicCardListArray[toGroupIndex].data.push(movedItem);
  }

  onAddExpenseClick(){
    this.addExpenseClick.emit(true);
  }

  RowInput: any = {
    lable: "",
    formControlName: "RowInput",
    dataField: "RowInput",
    isRequired: false,
    type: "number",
    placeholder: "Enter Amount",
  };

  RowDropdownTDS: any = {
    lable: "",
    formControlName: "TDSId",
    dataField: "TDSId",
    isRequired: false,
    placeholder: "Select TDS",
    isValueBind: true,
    isSearchByApi: true,  
  };

  onchangerowInput(event: any , row: any, index: any){
    var obj: any = {};
    obj.event = event;
    obj.row = row;
    obj.index = index;

    this.rowInputChange.emit(obj);
  }

  //  toggleDropdown() {
  //   this.showDropdown = !this.showDropdown;
  //   this.expandedCategoryIndex = null;
  // }

  
  // toggleCategory(index: number) {
  //   this.expandedCategoryIndex = this.expandedCategoryIndex === index ? null : index;
  // }

  activeDropdownIndex: number | null = null;

  toggleDropdown(index: number) {
    this.activeDropdownIndex = 
        this.activeDropdownIndex === index ? null : index; // toggle logic
    this.expandedCategoryIndex = null; // reset category when dropdown closes/opens
  }

  toggleCategory(index: number,category: any,data: any) {
     if (category === 'Set Bid Amount') {
    this.optionSelected.emit({ category:category, value: null, data: data });
    this.activeDropdownIndex = null;
    this.expandedCategoryIndex = null;
  } else if (category === 'Award Shipment') {
    this.optionSelected.emit({ category:category, value: null, data: data });
    this.activeDropdownIndex = null;
    this.expandedCategoryIndex = null;
  } else {
    // normal expand/collapse
    this.expandedCategoryIndex = 
      this.expandedCategoryIndex === index ? null : index;
  }
    // this.expandedCategoryIndex = 
    //     this.expandedCategoryIndex === index ? null : index;
  }


  selectOption(category: any, value: any,data:any) {
      this.optionSelected.emit({ category, value,data });
      this.showDropdown = false;
      this.activeDropdownIndex = null;
      this.expandedCategoryIndex = null;
    }

    NewButton(event,data){
      var obj: any = {};
      obj.data = data;
      obj.event = event;
      this.NewButtonTable.emit(obj);
    }

    onRecordDataShow(data){
    }

  getColor(shelfLifePercent: number) {
    if (shelfLifePercent <= 33) return 'red';
    if (shelfLifePercent <= 66) return 'yellow';
    return 'green';
  }

  setOpenedDropdown(index: number) {
    this.selectedDropdownIndex = index;
  }

  onImgError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.src = '../../../../assets/company/company-icon-mb.png';
  }

  getChangedValueFooter(value, data) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if(data.dataField == 'RoundOff') {
      this.FooterDataChanges.emit(newValue);
    }
  }

  GetTDSList(value: string, row: any, isScrollDown = false) {
    row.TDSDropdown.isSearch = true;

    let pageNo = 1;
    if (isScrollDown) {
      pageNo = Math.ceil(row.TDSDropdown.dropdownList.length / 20) + 1;
    }

    this._appService.Get('Sales', 'GetTDSList')
      .subscribe(res => {

        const list = res.map(x => ({
          name: x.Name,
          value: x.Id,
          Rate: x.Rate
        }));

        if (isScrollDown) {
          row.TDSDropdown.dropdownList = [
            ...row.TDSDropdown.dropdownList,
            ...list
          ];
        } else {
          row.TDSDropdown.dropdownList = list;
        }

        row.TDSDropdown.isSearch = false;
      }, () => {
        row.TDSDropdown.isSearch = false;
      });
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['TransactionType']) {
      this.TransactionType = changes['TransactionType'].currentValue;
    }

    if (this.TransactionType === 'PaymentReceipt' && this.tableDetails) {
      this.tableDetails.data = this.tableDetails.data.map(row => ({
        ...row,
        TDSDropdown: {
          lable: "",
          formControlName: "TDSId",
          dataField: "TDSId",
          isRequired: false,
          placeholder: "Select TDS",
          isValueBind: true,
          isSearchByApi: true,
          isSearch: false,
          dropdownList: row.TDSId
            ? [{
              value: row.TDSId,
              name: row.TaxDisplayName
            }]
            : []
        }
      }));
    }
  }
  //added by fahim 1/1/26 :)
  onRefreshParent(event){
    this.onRefreshList.emit(event);
  }

  //added by fahim 30-01-2026
  GetNewUnitsList(value: string, row: any, isScrollDown = false,bidRequestDropdownField) {
    bidRequestDropdownField.isSearch = true;

    let pageNo = 1;
    if (isScrollDown) {
      pageNo = Math.ceil(bidRequestDropdownField.dropdownList.length / 20) + 1;
    }

    this._appService.GetByQuery('OrdersByVehicle', 'GetNewUnitsList',value)
      .subscribe(res => {

        const list = res;

        if (isScrollDown) {
          bidRequestDropdownField.dropdownList = [
            ...bidRequestDropdownField.dropdownList,
            ...list
          ];
        } else {
          bidRequestDropdownField.dropdownList = list;
        }

        bidRequestDropdownField.isSearch = false;
      }, () => {
        bidRequestDropdownField.isSearch = false;
      });
  }

  //added by fahim 02-02-2026 :)  
  NewButtonForBidReq(event,data){
    var obj: any = {};
    obj.data = event.row;
    obj.event = event.event;
    this.NewButtonTable.emit(obj);
  }
  //END added by fahim 02-02-2026 :)  

  //added by fahim 05-02-2026 :)  
  OnViewEIR(path: any) {
    if (path) {
      var path1 =
        environment.apiUrl + path;
      window.open(path1, "");
    } else {
      this.toastr.error('EIR Copy not available !', 'Error');
      return;
    }
  }

  onClickOriginDestChange(event){
    this.callDMROriginDestChangeModal.emit(event);
  }
  //END added by fahim 05-02-2026 :)  

  onClickUploadOrderBulkEIR(event){
    this.openEIRCopyInParent.emit(event);
  }

  getChangedValueForFooter(event, row,dataFieldName=null) {
    if(dataFieldName == 'Discount'){
      row.amount = parseFloat(event);
    }

    this.footerDataChange.emit({ event, row, dataFieldName });
    // var type: any = 'Input';
  }

  openDropdownIndex: number | null = null;

  ShipmenttoggleDropdown(index: number) {
     this.openDropdownIndex = this.openDropdownIndex === index ? null : index;
  }

  onshipmentActionClick(row,actionName,index) {
    this.onActionClickOutput.emit({ row, actionName, index });
    this.openDropdownIndex = null;
  }

  onClickPBRoute(data){
    this.onClickPBRoutes.emit(data);
  }

  getType(value: any): string {
    return typeof value;
  }

  GetVehicleTypeList(value:any, isScrollDown = false) {
    this.VehicleType.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleType.dropdownList.length / 20) + 1;
    }
    this._appService.GetByOneParam('Vahicle', 'GetNewVehicleTypeList', value).subscribe(
      (res) => {
        let response = res || []; 
        let dropdownList = [...response];   
        if (
          isScrollDown &&
          response &&
          response.Total &&
          response.Total > this.VehicleType.dropdownList.length
        ){
          dropdownList = dropdownList.concat(this.VehicleType.dropdownList);
          this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] };
        }
        if (!isScrollDown) {
          this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] };
        }
        this.VehicleType.isSearch = false;
      },
      (error) => {
        this.VehicleType.isSearch = false;
        this.toastr.error(error._body.replace(/"/g, ""), "Error");
      }
    ); 
  }
  //added by BURHAN - 12-June-2026
  onExpandToggleClick(row: any, index: number, event: Event) {
    event.stopPropagation();
    row.isExpanded = !row.isExpanded;
    if (row.isExpanded && !(row as any).childColumns) {
      (row as any).childColumns = this.generateChildColumns(row.Customers);
    }
  }

  generateChildColumns(customers: any[]): any[] {
    if (!customers || customers.length === 0) return [];

    const firstCustomer = customers[0];
    return Object.keys(firstCustomer).map(key => ({
      columnName: key.replace(/([A-Z])/g, ' $1').trim(),
      dataFieldName: key,
      alignType: (key.includes('Value') || key.includes('Rate') || key.includes('Qty')) ? 'right' : 'left'
    }));
  }

  getExpandColumn(): any {
    return this.tableDetails.columnDetails.find(col => col.divType === 'expandToggle');
  }

  //end by BURHAN

  onClickOrderSummaryChange(row:any,CustPartnerId:any,columnName:any){
    this.onOrderSummaryChangeEmit.emit({ row,CustPartnerId,columnName });    
  }

  onCellClick(event: MouseEvent, row: any, column: any) {
      clearTimeout(this.clickTimer);

      this.clickTimer = setTimeout(() => {

          const value = row[column.dataFieldName];

          if (value !== null && value !== undefined && value !== '') {

              const textArea = document.createElement('textarea');
              textArea.value = String(value);

              textArea.style.position = 'fixed';
              textArea.style.left = '-999999px';
              textArea.style.top = '-999999px';

              document.body.appendChild(textArea);

              textArea.focus();
              textArea.select();

              try {
                  document.execCommand('copy');
                  console.log('Copied:', value);
              } catch (err) {
                  console.error('Copy failed:', err);
              }

              document.body.removeChild(textArea);
          }

          this.clickTimer = null;

      }, 250);
  }
}
